<template>
  <div>
    <div v-if="!paymentPack || !paymentPack.generated_at || editing">
      <div class="card-header">
        <h2 class="card-title">Payment Pack Documents</h2>
        <div>
          <button
            class="btn btn-primary"
            v-on:click.prevent="openGenerateDocumentModal"
          >
            New Document
          </button>
          <button
            class="btn btn-primary"
            v-on:click.prevent="openAddDocumentModal"
          >
            Add Documents To Payment Pack
          </button>
        </div>
      </div>
      <div class="card-body">
        <p>
          Select the documents to add to the payment pack by clicking the "Add
          Documents To Payment Pack" button.
        </p>
      </div>

      <div class="list-group no-margin">
        <draggable
          v-model="paymentPackDocuments"
          group="people"
          @start="drag = true"
          @end="drag = false"
        >
          <div
            class="list-group-item clearfix"
            v-for="document in paymentPackDocuments"
            :key="document.identifier"
          >
            <div class="float-left">
              <span class="draggable-item-body">
                <i class="material-icons">drag_handle</i>
                {{ document.type.label }} - {{ document.description }}
              </span>
            </div>
            <div class="float-right">
              <button
                type="button"
                class="btn btn-sm btn-primary"
                @click="viewDocument(document)"
              >
                View
              </button>
            </div>
          </div>
        </draggable>
      </div>

      <div class="card-footer clearfix">
        <div class="float-left">
          <button
            type="button"
            class="btn btn-default"
            @click="toggleEditing"
            v-if="editing"
          >
            Cancel
          </button>
        </div>
        <div class="float-right">
          <form-button :indicator="creating" v-on:clicked="submit">
            <span v-if="editing">Re-</span>Generate Payment Pack
          </form-button>
        </div>
      </div>
    </div>

    <div v-if="paymentPack && paymentPack.generated_at && !editing">
      <div class="card-header">
        <h2 class="card-title">Payment Pack</h2>
      </div>
      <div class="card-body">
        <div class="text-center">
          <p v-if="paymentPack.sent_at">
            Payment pack sent by {{ paymentPack.sent_by }} at
            {{ paymentPack.sent_at }}.
          </p>

          <button
            type="button"
            class="btn btn-primary"
            v-on:click.prevent="viewPaymentPack()"
          >
            View Payment Pack
          </button>
          <button
            type="button"
            class="btn btn-primary"
            v-on:click.prevent="toggleEditing()"
            v-if="!paymentPack.sent_at"
          >
            Edit Payment Pack
          </button>
        </div>
      </div>

      <div v-if="!paymentPack.sent_at">
        <div class="card-header">
          <h2 class="card-title">Send Payment Pack</h2>
        </div>
        <div class="card-body">
          <inputbox
            name="to"
            label="To"
            v-model="form.to"
            :show-error="form.errors.has('to')"
            :error-message="form.errors.get('to')"
            helper="Please enter the email addresses you would like to send the payment pack to."
            required
          ></inputbox>
          <inputbox
            name="cc"
            label="CC"
            v-model="form.cc"
            helper="Please enter the email addresses you would like to send a carbon copy."
          ></inputbox>
          <inputbox
            name="subject"
            label="Subject"
            v-model="form.subject"
            :show-error="form.errors.has('subject')"
            helper="Please enter the subject of the email address."
            :error-message="form.errors.get('subject')"
            required
          ></inputbox>
          <input-block
            name="body"
            label="Message"
            v-model="form.body"
            :show-error="form.errors.has('body')"
            helper="Please enter content of the email."
            :error-message="form.errors.get('body')"
            required
          ></input-block>

          <form-button :indicator="sending" v-on:clicked="send">
            Send Payment Pack
          </form-button>
        </div>
      </div>
    </div>

    <add-payment-pack-document
      :incident="incident"
      :show="modals.add"
      :documents="documents"
      :types="types"
      v-on:close="closeAddDocumentModal"
    ></add-payment-pack-document>

    <generate-document
      :incident="incident"
      :show="modals.generate"
      v-on:close="closeGenerateDocumentModal"
      v-on:generated="refresh"
      :types="types"
    ></generate-document>
  </div>
</template>
<script>
import Form from './../../../../Classes/Form';
import AddPaymentPackDocument from '../Children/AddPaymentPackDocument';
import GenerateDocument from '../Children/GenerateDocument';
import draggable from 'vuedraggable';

export default {
  props: {
    incident: {
      type: String,
      required: true
    }
  },

  components: {
    'add-payment-pack-document': AddPaymentPackDocument,
    'generate-document': GenerateDocument,
    draggable
  },

  computed: {
    paymentPack() {
      return this.$store.getters['Incident/paymentPack'];
    },
    paymentPackDocuments: {
      get() {
        if (this.paymentPack) {
          return this.paymentPack.documents;
        }

        return this.selectedDocuments;
      },
      set(value) {
        if (this.paymentPack) {
          this.paymentPack.documents = value;
          this.updateDocumentOrder(value);
        } else {
          this.selectedDocuments = value;
        }
      }
    }
  },

  data() {
    return {
      modals: {
        add: false,
        generate: false
      },
      form: new Form({
        to: null,
        cc: null,
        subject: null,
        body: null
      }),
      types: [],
      selectedDocuments: [],
      documents: [],
      creating: false,
      editing: false,
      sending: false
    };
  },

  mounted() {
    window.Ajax.get(`/payment-pack/${this.incident}`).then(response => {
      this.$store.commit('Incident/setPaymentPack', response.data);
    });

    this.getDocuments();

    window.Ajax.get('/document-types')
      .then(response => {
        this.types = response.data;
      })
      .catch(error => {});
  },

  methods: {
    getDocuments() {
      window.Ajax.get(`/incidents/${this.incident}/documents`)
        .then(response => {
          this.documents = response.data;
        })
        .catch(error => {});
    },

    openAddDocumentModal() {
      this.modals.add = true;
    },

    closeAddDocumentModal() {
      this.modals.add = false;
    },

    openGenerateDocumentModal() {
      this.modals.generate = true;
    },

    closeGenerateDocumentModal() {
      this.modals.generate = false;
    },

    viewDocument(document) {
      let url = `${window.AxisUK.storage}${document.hash}`;

      window.open(url, '_blank');
    },

    viewPaymentPack() {
      let url = `${window.AxisUK.storage}${this.paymentPack.hash}`;

      window.open(url, '_blank');
    },

    toggleEditing() {
      this.editing = !this.editing;
    },

    refresh() {
      this.modals.generate = false;
      this.getDocuments();
      window.toastify.success(
        'Success!',
        'The document was generated successfully!'
      );
    },

    submit() {
      this.creating = true;

      window.Ajax.post(`/payment-pack/${this.incident}/generate`, {})
        .then(response => {
          this.$store.commit('Incident/setPaymentPack', response.data);
          this.creating = false;
          this.editing = false;
          window.toastify.success(
            'Success!',
            'The payment pack was generated successfully!'
          );
        })
        .catch(error => {
          this.creating = false;
          window.toastify.error(
            'Error',
            'Oops, there was an error generating the payment pack'
          );
        });
    },

    updateDocumentOrder(documents) {
      const ids = this.paymentPackDocuments.map(
        document => document.identifier
      );

      window.Ajax.post(`/payment-pack/${this.incident}/documents/sort`, {
        documents: ids
      })
        .then(response => {
          window.toastify.success(
            'Success!',
            'The documents were sorted successfully!'
          );
        })
        .catch(error => {
          window.toastify.error(
            'Error',
            'Oops, there was an error while sorting the documents'
          );
        });
    },

    send() {
      this.sending = true;

      this.form
        .post(`/payment-pack/${this.incident}/send`)
        .then(response => {
          window.toastify.success(
            'Success!',
            'The payment pack was sent successfully!'
          );

          this.$store.commit('Incident/setPaymentPack', response);
          this.sending = false;
        })
        .catch(error => {
          window.toastify.error(
            'Error',
            'Oops, there was an error sending the payment pack'
          );

          this.sending = false;
        });
    }
  }
};
</script>
